import React from 'react'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  label: {
    fontFamily: 'Dazzed',
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '14px',
    letterSpacing: '0.15em',
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
    opacity: 0.5,
    marginBottom: 5,
    whiteSpace: 'nowrap'
  },
  labelElement: {
    display: 'block',
    cursor: 'inherit'
  }
}))

const GrinLabel = ({ color, children, className, fontSize = 12, htmlFor }) => {
  const classes = useStyles()
  const Element = htmlFor ? 'label' : 'div'

  return (
    <Element
      htmlFor={htmlFor}
      className={[classes.label, htmlFor ? classes.labelElement : '', className].join(' ')}
      style={{ color, fontSize }}
    >
      {children}
    </Element>
  )
}

export default GrinLabel
